import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=923c5334&scoped=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=923c5334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923c5334",
  null
  
)

export default component.exports